// @ts-nocheck
import React from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";

import KpiTile from '../../../ui/KpiTile';
import Tooltip from '../../../ui/Tooltip';
import {
  LineChartIcon, ClipboardIcon, MailIcon, ClockIcon, AlertCircleIcon,
} from '../../../ui/icons';

const fmt = (n) => (typeof n === 'number' ? n.toLocaleString() : n);
const pct = (num, den) => (den ? Math.round((num / den) * 100) : 0);

const Statistics = ({ store }) => {
  const { statSum, percentView } = store.analytics;
  const abandons = statSum('abandons');
  const formsStarted = statSum('forms_started');
  const abandonsWithEmail = statSum('unique_valid_abandoned_emails');
  const formsCompleted = formsStarted - abandons;
  const abandonsNoEmail = abandons - abandonsWithEmail;

  const tiles = [
    {
      label: 'Forms Started',
      icon: ClipboardIcon,
      value: percentView ? `${pct(formsStarted, formsStarted)}` : fmt(formsStarted),
      unit: percentView ? '%' : null,
      tip: 'Counted when a visitor clicks into your form.',
    },
    {
      label: 'Forms Completed',
      icon: LineChartIcon,
      value: percentView ? `${pct(formsCompleted, formsStarted)}` : fmt(formsCompleted),
      unit: percentView ? '%' : null,
      tip: 'Measured when a client clicks the submit button.',
    },
    {
      label: 'Abandons w/ Email',
      icon: MailIcon,
      value: percentView ? `${pct(abandonsWithEmail, formsStarted)}` : fmt(abandonsWithEmail),
      unit: percentView ? '%' : null,
      tip: 'A validly formatted email is input but the form is not submitted.',
    },
    {
      label: 'Abandons w/o Email',
      icon: AlertCircleIcon,
      value: percentView ? `${pct(abandonsNoEmail, formsStarted)}` : fmt(abandonsNoEmail),
      unit: percentView ? '%' : null,
      tip: 'A visitor abandons without inputting a complete email.',
    },
    {
      label: 'Total abandons',
      icon: ClockIcon,
      value: fmt(abandons),
      meta: percentView ? `${pct(abandons, formsStarted)}% of started` : 'all forms',
    },
  ];

  return (
    <section
      className="grid gap-4 mb-5"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
    >
      {tiles.map((t) => (
        <Tooltip key={t.label} content={t.tip} side="top">
          <KpiTile
            label={t.label}
            value={t.value}
            unit={t.unit}
            icon={t.icon}
            meta={t.meta}
            className="w-full"
          />
        </Tooltip>
      ))}
    </section>
  );
};

export default inject('store')(observer(Statistics));
